/* KŌ Motion — reveals content and hairlines as they scroll into view.
   Does nothing when the theme settings are off or reduced motion is set. */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var reveals = document.body.classList.contains('ko-motion-reveals');
  var lines = document.body.classList.contains('ko-motion-hairlines');
  if (!reveals && !lines) return;

  var show = function (el) { el.classList.add('ko-inview'); };

  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('.shopify-section, .ko-reveal').forEach(show);
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        show(entry.target);
        io.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

  if (lines) {
    document.querySelectorAll('.shopify-section').forEach(function (el) { io.observe(el); });
  }

  if (reveals) {
    var media = '#MainContent .banner__media, #MainContent .image-with-text__media, ' +
      '#MainContent .multicolumn-card, #MainContent .card-wrapper';
    var text = '#MainContent .banner__box, #MainContent .image-with-text__content, ' +
      '#MainContent .rich-text__blocks, #MainContent .title-wrapper-with-link, ' +
      '#MainContent .collection__title';
    document.querySelectorAll(media).forEach(function (el) {
      if (el.closest('.ko-hero')) return;
      el.classList.add('ko-reveal');
      io.observe(el);
    });
    document.querySelectorAll(text).forEach(function (el) {
      if (el.closest('.ko-hero')) return;
      el.classList.add('ko-reveal', 'ko-reveal--late');
      io.observe(el);
    });
  }
})();
